import AboutModal from '@/components/AboutModal';
import AlreadLogoutModal from '@/components/AlreadLogoutModal';
import PrivacyAndTermConditionModal from '@/components/PrivacyAndTermConditionModal';
import ReleaseModal from '@/components/ReleaseModal';
import useLanguage from '@/hooks/useLanguage';
import { useAppStateStore } from '@/zusttandStore/appState.store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useState } from 'react';
import { Toaster } from 'react-hot-toast';

const Providers = ({ children }: { children: React.ReactNode }) => {
  // Create the QueryClient once. Instantiating it inline on every render swaps the
  // client on each re-render, which orphans in-flight cache updates — e.g. a
  // mutation's onSuccess invalidateQueries would land on a client the mounted
  // components no longer read from, so lists never revalidate.
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            // staleTime: 2 * 60 * 1000, // 2 minutes
            staleTime: 0,
            cacheTime: 0,
          },
          mutations: {
            retry: 0,
          },
        },
      })
  );

  const { alreadyLogOut, setAlreadyLogOut } = useAppStateStore();

  return (
    <>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
      <Toaster position='top-center' reverseOrder={false} />
      <AlreadLogoutModal open={alreadyLogOut} onClose={() => setAlreadyLogOut(false)} />
      <ReleaseModal />
      <PrivacyAndTermConditionModal />
      <AboutModal />
    </>
  );
};

export default Providers;
